import { createAction } from '@reduxjs/toolkit';

const workspacesReset = createAction('workspaces/reset');

export { workspacesReset };
